<!--
 * @Description: e签宝编辑模板
 * @Author: 钱磊
 * @Date: 2022-08-31 14:18:44
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-11-21 14:46:03
-->
<!--  -->
<template>
  <div class="h100">
    <div class="h100">
      <w-split class="h100" v-model="splitValue">
        <div class="w-page-main left" slot="left">
          <div class="w-page-container pdb10">
            <el-form
              ref="editForm"
              :model="contractData"
              size="medium"
              label-width="90px"
            >
              <el-form-item label="业务：">
                <span class="blue">{{ contractData.bizTypeName }}</span>
              </el-form-item>
              <el-form-item label="业务场景：">
                <span class="blue">{{ contractData.bizSceneName }}</span>
              </el-form-item>
            </el-form>
            <hr />
            <vxe-table
              :data="tableObj.tableData"
              :loading="tableObj.loading"
              :border="tableObj.border"
              :size="tableObj.size"
              :resizable="tableObj.resizable"
              :height="tableObj.height"
              highlight-current-row
              highlight-hover-row
              show-overflow="tooltip"
              show-header-overflow="tooltip"
              class="mt20"
            >
              <vxe-table-column
                field="name"
                title="字段名称"
                align="center"
              ></vxe-table-column>
              <vxe-table-column
                field="key"
                title="控件编码"
                align="center"
              ></vxe-table-column>
              <vxe-table-column title="操作" align="center" width="80">
                <template v-slot="{ row }">
                  <el-button
                    type="success"
                    size="small"
                    round
                    plain
                    class="table-btn"
                    @click="handleCope(row)"
                  >
                    复制
                  </el-button>
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </div>
        <div class="w-table-layout right" slot="right">
          <p class="title">编辑模板</p>
          <hr class="line-cut" />
          <div class="content">
            <p class="tips">
              操作提示：拖动E签宝的左侧的基础控件至合同某一位置时，将最左侧的业务字段内容复制到E签宝右侧的自定义控件编码输入框内。
            </p>
            <div class="opration mt10">
              <iframe
                :src="contractData.docTemplateCreateUrl"
                style="height: 100%; width: 100%"
              ></iframe>
            </div>
          </div>
        </div>
      </w-split>
    </div>
    <div class="footer text-center">
      <el-button size="mini" @click="auditDialog">提交配置</el-button>
    </div>
  </div>
</template>

<script>
import * as API from "api/modules/es/es_template.js";
export default {
  data() {
    return {
      splitValue: 0.2,
      contractData: {},
      // 表格对象
      tableObj: {
        tableData: [],
        loading: false,
        border: true,
        resizable: true,
        size: "small",
        // height: "100%",
      },
    };
  },
  components: {},
  mounted() {
    if (this.$getSessionItem("contractData")) {
      this.contractData = JSON.parse(this.$getSessionItem("contractData"));
      // 移除 避免污染
      // this.$removeSessionItem("contractData");
    }
    console.log(this.contractData);
    this.getConfigList();
  },
  methods: {
    // 获取业务字段列表
    getConfigList() {
      switch (this.contractData.bizScene) {
        case "1001028001001"://聚易厅
          API.getJytTemplateConfig({ code: this.contractData.bizScene }).then(
            (res) => {
              this.tableObj.tableData = res.data;
            }
          );
          break;
        case "1001028006001"://租赁通
          API.getZltTemplateConfig({ code: this.contractData.bizScene }).then(
            (res) => {
              this.tableObj.tableData = res.data;
            }
          );
          break;
        default:
          break;
      }
    },
    // 提交配置
    auditDialog() {
      let params = {
        id: this.contractData.id,
        content: this.contractData.content,
        docTemplateId: this.contractData.docTemplateId,
        docTemplateName: this.contractData.docTemplateName,
        bizType: this.contractData.bizType,
        bizScene: this.contractData.bizScene,
        docTemplateCreateUrl: this.contractData.docTemplateCreateUrl,
      };
      API.saveOrUpdate(params).then((res) => {
        this.$emit("close");
        this.$router.push({
          path: "/es-contract-template-maintain-new",
        });
      });
    },
    // 复制控件编码
    handleCope(row) {
      //创建input标签,将input的值设置为需要复制的内容
      let input = document.createElement("input");
      input.value = row.key;
      //添加并选中input标签，执行复制
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      this.$message.success("复制成功!");
      //移除input标签
      document.body.removeChild(input);
    },
  },
  computed: {},
};
</script>
<style scoped lang='less'>
.w-page-main {
  overflow: auto !important;
}
.w-page-main {
  padding-top: 10px;
}
.el-form-item {
  margin-bottom: 10px;
}
/deep/.el-form-item--medium .el-form-item__content,
.el-form-item--medium .el-form-item__label {
  line-height: 19px !important;
}
/deep/.el-form-item__label {
  line-height: 19px !important;
}
.blue {
  color: #0000ff;
}
.title {
  line-height: 48px;
  font-size: 16px;
  text-align: center;
  color: #000;
  margin-top: 10px;
}
.line-cut {
  margin: 10px 0;
}
.content {
  width: 100%;
  padding: 10px 20px;
}
.tips {
  font-size: 13px;
  color: #0000ff;
}
.opration {
  height: 670px;
}
.footer {
  position: absolute;
  top: 88px;
  right: 135px;
  .el-button {
    height: 28px !important;
  }
}
</style>